import {validators} from 'vue-form-generator';

export const firstName = {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            id: 'first-name',
                            model: 'firstName',
                            required: true,
                            disabled: false,
                            styleClasses: "col xs-12 md-6",
                            min: 2,
                            validator: [validators.string],
}

export const lastName = {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            id: 'last-name',
                            model: 'lastName',
                            required: true,
                            disabled: false,
                            styleClasses: "col xs-12 md-6",
                            min: 2,
                            validator: [validators.string],
}
